import AbstractComponent from "./abstract-component";

const createTemplate = () => {
  return (
    `<div class="banner__swiperWrap">
      <button class="swiper__button swiper__button--prev" type="button" title="Предыдущий">
        Предыдущий
        <svg className="" width="10" height="10" aria-hidden="true">
          <use href="sienge/img/sprite.svg#arrow-small-left"></use>
        </svg>
      </button>

      <div class="swiper-pagination"></div>

      <button class="swiper__button swiper__button--next" type="button" title="Следующий">
        Следующий
        <svg className="" width="10" height="10" aria-hidden="true">
          <use href="sienge/img/sprite.svg#arrow-small-right"></use>
        </svg>
      </button>
    </div>`
  );
};

export default class BannerNavComponent extends AbstractComponent {
  // constructor({title = ``}) {
  //   super();

  //   this._title = title;
  // }

  getTemplate() {
    return createTemplate();
  }
}
